import React, { useEffect, useState, useMemo, useRef } from 'react';
import 'antd/dist/antd.css';
import { Button } from 'antd';
import '../chatComponent/chat.css';
import { getMessagesById } from '../api/api';

const ChatMessages = ({ props }: any) => {
  const [state, setState] = useState([]);
  const [sessionNumber, setSessionNumber] = useState<{
    id: any;
    user_id: any;
    is_group: any;
    session_id: any;
  }>({
    id: null,
    user_id: null,
    is_group: null,
    session_id: null,
  });
  const [chat, setChat] = useState<
    { id: any; content: any; sender_name: any; receiver_id: any; send_timestamp: any; send: any }[]
  >([]);

  const ref = useRef<any>(null);
  useEffect(() => {
    if (ref) {
      ref.current.addEventListener('DOMNodeInserted', (event: any) => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight });
      });
    }
  }, []);
  const propsTakeFromChat = useMemo(() => {
    // console.log('ChatMessages', props);
    if (props !== undefined) {
      setState(props.allChatMessages);
      setSessionNumber(props.sessionIds);
      setChat(props.Messages);
    }
  }, [props]);

  const getMessagesByIdFunc = (checkMessageStorage: any) => {
    getMessagesById(checkMessageStorage.links.next)
      .then((res: any) => {
        checkMessageStorage.links.next = res.links.next;
        checkMessageStorage.data = res.data.concat(checkMessageStorage.data);
        setChat(checkMessageStorage.data);
      })
      .catch(() => {
        props.catchError().then(() => {
          getMessagesByIdFunc(checkMessageStorage);
        });
      });
  };
  //Для загрузки предыдущих сообщений из бд
  const loadPreviousMessages = () => {
    // console.log(state, sessionNumber, chat);
    // console.log(checkMessageStorage.links, 'daw');
    const checkMessageStorage: any = state.find(
      (item: any) => item.session_id === sessionNumber.session_id
    );
    // console.log('checkMessageStorage', checkMessageStorage);
    if (checkMessageStorage) {
      if (checkMessageStorage.links.next !== null) {
        getMessagesByIdFunc(checkMessageStorage);
      }
    }
  };
  return (
    <>
      {chat.length ? (
        <div className="button__wrapper">
          <Button type="link" className="button__previos-messeges" onClick={loadPreviousMessages}>
            Загрузить предыдущие
          </Button>
        </div>
      ) : null}
      <div className="wrapper__massege" ref={ref}>
        {sessionNumber.session_id ? (
          chat.length ? (
            chat?.map((item: any) => {
              const dateForMessages = new Date(item.send_timestamp * 1000);
              if (item.sender_name === 'Я') {
                return (
                  <div key={item.id} className="wrapper__massege-me">
                    <div className="message__me">
                      <div className="message__title">{item.sender_name}:</div>
                      <div className="message__description">{item.content}</div>

                      <div className="message__date">
                        {dateForMessages.toLocaleTimeString().slice(0, -3) +
                          ' ' +
                          dateForMessages.toLocaleDateString()}
                        {item.send === 'err' ? (
                          <div className="message__description--error">
                            {' '}
                            сообщение не отправлено
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={item.id} className="wrapper__massege-you">
                    <div className="message__you">
                      <div className="message__title">{item.sender_name}:</div>
                      <div className="message__description">{item.content}</div>
                      <div className="message__date">
                        {dateForMessages.toLocaleTimeString().slice(0, -3) +
                          ' ' +
                          dateForMessages.toLocaleDateString()}
                        {item.send === 'err' ? <div>error</div> : null}
                      </div>
                    </div>
                  </div>
                );
              }
            })
          ) : (
            <div className="wrapper__massege-info">Нет сообщений</div>
          )
        ) : (
          <div className="wrapper__massege-info">Выберите чат</div>
        )}
      </div>
      {/* ///////////////////////////////////////////////////// */}
    </>
  );
};

export default ChatMessages;
